import { useHistory, useLocation } from 'react-router-dom';
import {
  withTypes,
  Field,
} from 'react-final-form';
import classNames from 'classnames';
import queryString from 'query-string';
import { t } from 'ttag';

import SendIcon from '@svg/send.svg';
import { login } from '@urls';
import { Product } from '@hook/useProductFavorite';
import { required } from '@utils/validators';
import { Button } from '@ui/Button';
import { FormError } from '@ui/FormError';
import { Input } from '@ui/Input';
import { ProductFavoritesToggleContainer } from '@containers/ProductFavoritesToggle';
import { ProductDetailsCreateOrderButtonsContainer } from '@containers/ProductDetailsCreateOrderButtons';

import s from './ProductDetailsStickyBar.sss';

export interface FormData {
  body?: string,
}

interface Props {
  isAuth?: boolean,
  isLoading?: boolean,
  threadUrl?: string,
  product: Product | null,
  canStartDialog?: boolean,
  isOwnerIsRestrictedByBankId?: boolean,
  onSendMessage: (formData: FormData) => void,
}

export const ProductDetailsStickyBar: React.FC<Props> = ({
  isAuth,
  isLoading,
  threadUrl,
  product,
  canStartDialog,
  isOwnerIsRestrictedByBankId,
  onSendMessage,
}) => {
  const location = useLocation();
  const history = useHistory();
  const { Form } = withTypes<FormData>();

  const handleMessageFormClick = () => {
    if (!isAuth) {
      const loginUrl = history.createHref({
        pathname: login,
        search: queryString.stringify({
          next: location.pathname,
        }),
      });

      window.location.href = loginUrl;
    }
  };

  return (
    (
      <div className={s.root}>
        <Form
          onSubmit={onSendMessage}
          render={({ handleSubmit, submitting, submitError }) => (
            <form
              className={s.form}
              onSubmit={handleSubmit}
            >
              <div className={s.row}>
                {product && (
                <ProductFavoritesToggleContainer
                  product={product}
                  type="Product"
                />
                )}

                <ProductDetailsCreateOrderButtonsContainer isInStickyBar={true} />

                {!isOwnerIsRestrictedByBankId && !threadUrl && (
                <Field
                  name="body"
                  validate={required}
                >
                  {({ input, meta }) => (
                    <div
                      className={s.field}
                      onClick={handleMessageFormClick}
                    >
                      <Input
                        {...input}
                        inputClassName={s.input}
                        placeholder={t`Написати продавцю`}
                        disabled={!canStartDialog || isLoading}
                        invalid={(meta.touched && meta.error) || meta.submitError}
                        error={(meta.touched && meta.error) || meta.submitError}
                        value={input.value || ''}
                      />
                      {submitError && (
                      <FormError>
                        {submitError}
                      </FormError>
                      )}

                      <Button
                        className={s.submit}
                        theme="text"
                        type="submit"
                        disabled={submitting || isLoading}
                      >
                        <SendIcon
                          className={classNames(s.icon, {
                            [s.iconThemeGreen]: !!input.value,
                          })}
                          width="24"
                          height="24"
                        />
                      </Button>
                    </div>
                  )}
                </Field>
                )}

                {threadUrl && (
                <Button
                  theme="secondary"
                  href={threadUrl}
                >
                  {t`Перейти до листування`}
                </Button>
                )}
              </div>
            </form>
          )}
        />
      </div>
    )
  );
};
